export default ({...props}) => {
  const {panelHighlight} = props.theme
  return `
        color: ${panelHighlight.foreground};
    `
}
